export const stockTutorialSteps = [
  {
    target: '#stock-module-header',
    title: 'Centro de stock',
    content: 'Desde esta cabecera leés el estado del depósito, abrís el tutorial y entrás al módulo donde viven compras, salidas, controles y movimientos.',
    narration: 'Desde esta cabecera leés el estado del depósito, abrís el tutorial y entrás al módulo donde viven compras, salidas, controles y movimientos.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#stock-nav-panel',
    title: 'Secciones del depósito',
    content: 'Esta navegación separa programación, productos, compras, salidas, movimientos, hojas de control, estadísticas y ayuda para que todo quede ordenado.',
    narration: 'Esta navegación separa programación, productos, compras, salidas, movimientos, hojas de control, estadísticas y ayuda para que todo quede ordenado.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '#stock-main-panel',
    title: 'Panel activo',
    content: 'Acá cambia el contenido según la sección elegida, sin salir del mismo módulo, para trabajar todo el ciclo del stock desde un solo lugar.',
    narration: 'Acá cambia el contenido según la sección elegida, sin salir del mismo módulo, para trabajar todo el ciclo del stock desde un solo lugar.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#stock-nav-assistant',
    title: 'Guía y soporte del depósito',
    content: 'Desde acá abrís ayuda contextual para reubicarte rápido dentro del módulo o retomar el recorrido guiado si hace falta.',
    narration: 'Desde acá abrís ayuda contextual para reubicarte rápido dentro del módulo o retomar el recorrido guiado si hace falta.',
    placement: 'left',
    disableBeacon: true,
  },
];

export default stockTutorialSteps;
